import Alpine from 'alpinejs';

import { VideoSettings } from '@/stores/video_settings/video_settings';

if (!Alpine.store('videoSettings')) {
    Alpine.store('videoSettings', new VideoSettings());
}
